import { ApiRequestError } from '@concours/api-client'

/** Message lisible pour une erreur d'API (le détail technique reste dans la console). */
export function errorMessage(
  error: unknown,
  fallback = 'Une erreur est survenue. Réessayez.'
): string {
  if (error instanceof ApiRequestError) {
    if (error.status === 429) {
      const retry = (error.details as { retryAfter?: number } | undefined)?.retryAfter
      return retry ? `${error.message} (dans ${Math.ceil(retry / 60)} min)` : error.message
    }
    if (error.isValidation) return 'Certains champs sont à corriger.'
    return error.message || fallback
  }
  return fallback
}

export function fieldErrors(error: unknown): Record<string, string> {
  return error instanceof ApiRequestError ? error.fieldErrors : {}
}
